import type { BoggleResolvedChallengeParameter } from '~/boggle/config/challenges/modTypes'
import type { BoggleChallengeBonusDefinition } from '~/boggle/config/bonuses/bonusDefinition'

export function formatResolvedBonusDisplayFromDefinition(
  definition: BoggleChallengeBonusDefinition,
  parameters: Record<string, BoggleResolvedChallengeParameter>,
) {
  return (
    definition.formatResolvedDisplay?.({
      parameters,
    }) ?? {
      description: definition.description,
      name: definition.name,
      shortLabel: definition.shortLabel,
    }
  )
}
